import axios from "axios";

const api = axios.create({
    timeout: 10000,
    headers: {
        "Content-Type": "application/json"
    }
})

api.interceptors.request.use(
    (config) => {

        config.baseURL = process.env.NEXT_PUBLIC_API_URL;

        return config
    },
    (error) => Promise.reject(error)
)

export default api;